/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

export type FeatureFlagNameEnum = typeof FeatureFlagNameEnum[keyof typeof FeatureFlagNameEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeatureFlagNameEnum = {
  fund_family_setup: 'fund_family_setup',
  credit_facility_expenses: 'credit_facility_expenses',
  display_time_weighted_returns: 'display_time_weighted_returns',
  cap_call_reallocations: 'cap_call_reallocations',
  backdated_cap_call_reallocations: 'backdated_cap_call_reallocations',
  hypo_waterfalls_with_custom_pnl_input: 'hypo_waterfalls_with_custom_pnl_input',
  async_workflow_improvements: 'async_workflow_improvements',
  inter_entity_fund_structure: 'inter_entity_fund_structure',
  refresh_out_of_date_events: 'refresh_out_of_date_events',
  maybern_assistant: 'maybern_assistant',
  reallocate_adjustments: 'reallocate_adjustments',
  use_linked_fee_offsets_to_calls_for_offsets: 'use_linked_fee_offsets_to_calls_for_offsets',
  waterfall_structured_calculations: 'waterfall_structured_calculations',
  general_ledger: 'general_ledger',
  removing_pitas: 'removing_pitas',
  write_edge_weights: 'write_edge_weights',
  tpg_demo: 'tpg_demo',
  gauge_fee_waivers_fees: 'gauge_fee_waivers_fees',
  fast_fail_exports: 'fast_fail_exports',
  updated_allocation_graph_creates: 'updated_allocation_graph_creates',
} as const;
